// extracted by css-extract-rspack-plugin
export default {"error-tooltip":"c7eiHr","errorTooltip":"c7eiHr"};